import { ColDef } from 'ag-grid-enterprise';

export const attributeColDefs: ColDef[] = [
  {
    field: 'entityTypeId',
    headerName: 'Entity Type',
    autoHeaderHeight: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'identifier.0',
    headerName: 'Identifier',
    autoHeaderHeight: true,
    sortable: false, // Not supported by server
  },
  {
    field: 'status',
    headerName: 'Status',
    autoHeaderHeight: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'errorTypeId',
    headerName: 'Error Type',
    autoHeaderHeight: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'notificationTypeId',
    headerName: 'Notification Type',
    autoHeaderHeight: true,
    suppressAutoSize: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'error',
    headerName: 'Error Description',
    autoHeaderHeight: true,
    sortable: false, // Not supported by server
    tooltipValueGetter: (params) => {
      // Return the formatted value from the cell
      return params.valueFormatted || params.value || '';
    },
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    autoHeaderHeight: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'retryCount',
    headerName: 'Retry Count',
    autoHeaderHeight: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'nextScheduleAt',
    headerName: 'Next Schedule At',
    autoHeaderHeight: true,
    suppressAutoSize: true,
    sortable: true, // Server-side sortable
  },
  {
    field: 'action',
    headerName: 'Action',
    suppressAutoSize: true,
    cellRenderer: 'SyncButtonComponent',
    floatingFilter: false,
    suppressFloatingFilterButton: true,
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressHeaderContextMenu: true,
    sortable: false,
  },
];
